import BudgeaAPI from "../../../tools/budgeaAPI";
import Queries from "../../../queries/queries2";
import React from "react";
import Spinner from "../../../elements/Spinner/Spinner";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import { parseLocation } from "../PaymentList/BudgeaUrlHandler";
import { withRouter } from "react-router-dom";

const GetBiConnexion = graphql(Queries.GetBiConnexion, {
  name: "GetBiConnexion",
  options: { fetchPolicy: "network-only" }
});

const createAccessToken = graphql(Queries.createAccessToken, {
  name: "createAccessToken",
  options: { fetchPolicy: "no-cache" }
});

const syncronizeProviderAccounts = graphql(Queries.syncronizeProviderAccounts, {
  name: "syncronizeProviderAccounts"
});

class BudgeaHandlerPure extends React.Component {
  constructor(props) {
    super();
    this.state = { props: props };
  }

  // const componentLifecycle = lifecycle({
  static getDerivedStateFromProps = async (props, state) => {
    // componentDidMount = async () => {
    console.log("*BudgeaHandler componentDidMount", props);

    if (props && props.GetBiConnexion && props.GetBiConnexion.company) {
      const biConnection = props.GetBiConnexion.company.biConnexion;

      // console.log("biConnection", biConnection);
      const BiUserId = biConnection ? biConnection.userId : undefined;

      const BiAccessToken = biConnection ? biConnection.accessToken : undefined;

      console.log("BiUserId", BiUserId);
      console.log("BiAccessToken", BiAccessToken);
      const params = {
        redirect_uri: process.env.REACT_APP_BUDGEA_REDIRECTION_URL,
        client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
        client_secret: process.env.REACT_APP_BUDGEA_CLIENT_SECRET
      };
      console.log(
        "BudgeaAPI params",
        process.env.REACT_APP_BUDGEA_ENDPOINT,
        params
      );
      let client = new BudgeaAPI(process.env.REACT_APP_BUDGEA_ENDPOINT, params);
      if (BiAccessToken && BiUserId) {
        client.setAccessToken(BiAccessToken);
        client.setClientId(BiUserId);
      }

      const hasTokenInDb = client.getAccessToken();
      console.log("hasTokenInDb", hasTokenInDb);

      try {
        console.log("1 parse location");

        await parseLocation(client, props.location);
      } catch (e) {
        console.log("componentDidMount error", e);

        props.history.push("/payments");
        // this.props.sendFailureNotification(e);
      }

      console.log("2 get token");
      const access_token = client.getAccessToken();
      console.log("client.access_token", access_token);

      if (!hasTokenInDb) {
        // store token
        const variables = {
          companyId: props.companyId,
          accessToken: access_token
        };
        console.log("store access token", variables);
        await props.createAccessToken({
          variables
        });
      }

      console.log("syncronizeProviderAccounts", props.companyId);
      const res =
        // await
        props.syncronizeProviderAccounts({
          variables: {
            companyId: props.companyId
          }
        });

      console.log("res", res);
      props.history.push("/payments");
    }
    // return;
  };

  render = () => {
    // const { history, companyId, location } = this.props;
    return (
      // <Query query={Queries.GetBiConnexion} variables={{ companyId }}>
      //   {({ loading, error, refetch, data: { company } }) => {
      //     if (loading) return null;
      //     if (error) return `Error!: ${error}`;

      // return (
      <div>
        <Spinner size="lg" fullScreen />
      </div>
      // );

      //     console.log("BudgeaHandlerPure");
      //     if (company) {
      //       const biConnection = company.biConnexion;

      //       // console.log("biConnection", biConnection);
      //       const BiUserId = biConnection ? biConnection.userId : undefined;

      //       const BiAccessToken = biConnection
      //         ? biConnection.accessToken
      //         : undefined;

      //       console.log("BiUserId", BiUserId);
      //       console.log("BiAccessToken", BiAccessToken);

      //       console.log(
      //         "REACT_APP_BUDGEA_REDIRECTION_URL",
      //         process.env.REACT_APP_BUDGEA_REDIRECTION_URL
      //       );
      //       let client = new BudgeaAPI(process.env.REACT_APP_BUDGEA_ENDPOINT, {
      //         redirect_uri: process.env.REACT_APP_BUDGEA_REDIRECTION_URL,
      //         client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
      //         client_secret: process.env.REACT_APP_BUDGEA_CLIENT_SECRET
      //       });
      //       if (BiAccessToken) {
      //         client.setAccessToken(BiAccessToken);
      //         client.setClientId(BiUserId);
      //       }

      //       const hasTokenInDb = client.getAccessToken();
      //       console.log("hasTokenInDb", hasTokenInDb);

      //       try {
      //         console.log("1 parse location");
      //         parseLocation(client, location);
      //       } catch (e) {
      //         console.log("componentDidMount error", e);
      //         // this.props.sendFailureNotification(e);
      //       }

      //       // console.log("2 get token");
      //       // const access_token = client.getAccessToken();
      //       // console.log("client.access_token", access_token);
      //     }
      //     return (
      //       <div>
      //         <Spinner size="lg" fullScreen />
      //       </div>
      //     );
      //   }}
      // </Query>
    );
  };

  // });
}

export default compose(
  GetBiConnexion,
  createAccessToken,
  syncronizeProviderAccounts
  // componentLifecycle
  // pure
)(withRouter(BudgeaHandlerPure));
